import { render, staticRenderFns } from "./ReleaseNotesPDF.vue?vue&type=template&id=4850585f&"
import script from "./ReleaseNotesPDF.vue?vue&type=script&lang=js&"
export * from "./ReleaseNotesPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports